//     This code was generated by a Reinforced.Typings tool.
//     Changes to this file may cause incorrect behavior and will be lost if
//     the code is regenerated.

export abstract class CoreWebStimulusControllers
{
	public static turboFrame: string = `turbo-frame`;
	public static viewOrEditForm: string = `view-or-edit-form`;
	public static hint: string = `hint`;
}
